module.exports = __webpack_public_path__ + "media/application/assets/images/spot3-affb10446081bb8e1d55c7bf0e00e453.jpg";